/* -------------------------------------------------------------------------- */
/*                        Empty state styles                        */
/* -------------------------------------------------------------------------- */

:host {
  @apply relative inline-block;
}
